import { Injectable } from '@angular/core';
import { SUPPORTED_OPPORTUNITY_COMPANY_ROLE_IDS } from '@models/OpportunityCompanyRoleIds';
import { EntityTypes } from '@models/enums/EntityTypes';
import { lastValueFrom } from 'rxjs';
import { BuildingContactRoleClient, BuildingContactRoleView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BuildingContactRoleService {
    constructor(private readonly client: BuildingContactRoleClient) {}

    async getById(id: number): Promise<BuildingContactRoleView> {
        return await lastValueFrom(this.client.buildingContactRoleGetById(id));
    }

    async getByUsage(entityTypeId: number, filterText: string | undefined): Promise<BuildingContactRoleView[]> {
        return await lastValueFrom(this.client.buildingContactRoleGetByUsage(entityTypeId, filterText));
    }

    async search(): Promise<BuildingContactRoleView[]> {
        return await lastValueFrom(this.client.buildingContactRoleGetByUsage(EntityTypes.Contact, undefined));
    }

    async getOpportunityCompanyRoles(): Promise<BuildingContactRoleView[]> {
        // Opportunity Company roles are sourced from the Contact-usage role superset.
        const roles = await this.getByUsage(EntityTypes.Contact, undefined);
        return roles.filter(
            (role) => typeof role.id === 'number' && SUPPORTED_OPPORTUNITY_COMPANY_ROLE_IDS.includes(role.id)
        );
    }
}
